import { IService } from 'src/core/infrastructure';
import {
  ITellStoryDetailReq,
  ITellStoryDetailRes,
  ITellStoryLanguageRes,
  ITellStoryStoriesReq,
  ITellStoryStoriesRes,
  ITellStorySubmitReq,
  ITellStoryTopicsReq,
  ITellStoryTopicsRes,
  ITellStoryVoiceToTextReq,
} from './type';
import request from '../request';
import { AxiosResponse } from 'axios';

export async function getTellStoryLanguagesFn() {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };
  const data: IService = {
    method: 'POST',
    relativePath: '/get-tellstory-langs',
    headers: header,
  };

  const response =
    await request.requestService<AxiosResponse<ITellStoryLanguageRes[]>>(data);
  return response.data;
}

export async function getChildrenList() {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };
  const data: IService = {
    method: 'POST',
    relativePath: '/get-tellstory-langs',
    headers: header,
  };

  const response =
    await request.requestService<AxiosResponse<ITellStoryLanguageRes[]>>(data);
  return response.data;
}

export const getChildList = async (): Promise<any> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };

  const data: IService<any> = {
    method: 'GET',
    relativePath: 'children-list',
    headers: header,
  };

  const response = await request.requestService<AxiosResponse<any[]>, any>(
    data,
  );

  return response;
};

export const getTellStoryTopics = async (
  requestData: ITellStoryTopicsReq,
): Promise<ITellStoryTopicsRes[]> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };

  const data: IService<ITellStoryTopicsReq> = {
    method: 'POST',
    relativePath: 'get-tellstory-trainingtopics',
    headers: header,
    data: {
      child_id: requestData.child_id,
      lang_id: requestData.lang_id,
    },
  };

  const response =
    await request.requestService<AxiosResponse<ITellStoryTopicsRes[]>>(data);

  return response.data;
};

export const getTellStoryStories = async (
  requestData: ITellStoryStoriesReq,
): Promise<ITellStoryStoriesRes[]> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };

  const data: IService<ITellStoryStoriesReq> = {
    method: 'POST',
    relativePath: 'get-tellstory-stories',
    headers: header,
    data: {
      child_id: requestData.child_id,
      lang_id: requestData.lang_id,
      topic_id: requestData.topic_id,
    },
  };

  const response =
    await request.requestService<AxiosResponse<ITellStoryStoriesRes[]>>(data);

  return response.data;
};

export const getTellStoryDetail = async (
  requestData: ITellStoryDetailReq,
): Promise<ITellStoryDetailRes[]> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };

  const data: IService<ITellStoryDetailReq> = {
    method: 'POST',
    relativePath: 'get-tellstory-story_contents',
    headers: header,
    data: {
      story_id: requestData.story_id,
      child_id: requestData.child_id,
    },
  };

  const response =
    await request.requestService<AxiosResponse<ITellStoryDetailRes[]>>(data);

  return response.data;
};

export const getTellStoryVoiceToText = async (
  requestData: ITellStoryVoiceToTextReq,
): Promise<any> => {
  const data: IService = {
    method: 'post',
    relativePath: '/tellstory/voice-to-text',
    data: requestData,
  };

  const response = await request.requestService<AxiosResponse<any>>(data);
  return response.data;
};




export const submitTellStory = async (
  requestData: ITellStorySubmitReq,
): Promise<any> => {
  const data: IService = {
    method: 'post',
    relativePath: '/tellstory/submit-response-story',
    data: requestData,
  };

  const response = await request.requestService<AxiosResponse<any>>(data);
  return response.data;
};